const LOGO_SRC = '/assets/LOGO-new.png';
// Reversed (white knockout) lockup for navy brand panels — the full-colour
// artwork is dark navy on transparency and disappears against them.
const LOGO_SRC_REVERSED = '/assets/LOGO-new-white.png';

export default function AcquireOSLogo({ size = 44, onDark = false }) {
  return (
    <img
      src={onDark ? LOGO_SRC_REVERSED : LOGO_SRC}
      alt="AcquireOS AI"
      style={{
        display: 'block',
        height: size,
        width: 'auto',
        maxWidth: '100%',
        objectFit: 'contain',
      }}
    />
  );
}
